import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { FeatureIcon, formatFeatureDate, updateTypeLabel } from '@/components/ui/featureIcons';
import { useLanguage } from '../utils/useLanguage';

export default function FeatureSliderCard({ feature }) {
  const { language, t } = useLanguage();
  const title = language === 'en' ? (feature.title_en || feature.title_de) : feature.title_de;
  const subtitle = language === 'en' ? (feature.subtitle_en || feature.subtitle_de) : feature.subtitle_de;
  const dateLabel = formatFeatureDate(feature, language);
  const typeLabel = updateTypeLabel(feature.update_type, language);

  return (
    <Link to={`/updates/${feature.slug}`} className="block h-full">
      <Card className="group rounded-md border-0 bg-card hover:bg-emerald-50 text-card-foreground shadow-sm hover:shadow-md transition-shadow h-full">
        <CardContent className="p-6">
          <div className="flex items-center gap-2 mb-3 flex-wrap">
            <div className="w-9 h-9 rounded-full bg-emerald-50 flex items-center justify-center shrink-0">
              <FeatureIcon icon={feature.icon} size={18} />
            </div>
            {dateLabel && <span className="text-xs text-gray-500">{dateLabel}</span>}
            <span className="inline-flex items-center rounded-full bg-emerald-100 text-emerald-700 text-[11px] font-semibold px-2.5 py-0.5">
              {typeLabel}
            </span>
          </div>
          <h3 className="title-underline text-xl font-semibold text-emerald-600 group-hover:text-emerald-900 mb-2">
            {title}
          </h3>
          <p className="text-md text-gray-600 leading-relaxed">{subtitle}</p>
        </CardContent>
      </Card>
    </Link>
  );
}